import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { PreSaleModels } from '../../models/presale';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import { NoticeConfig } from 'iview';
import ASpaceInBetweenTopZero from '../ASpaceInBetweenTopZero/a.space.inbetween.top.zero.vue';

@Component({
   components: {
      ASpaceInBetweenTopZero
   }
})
export default class PresaleListRow extends Vue {
   public title: string = 'PresaleListRow';

   public isOffStaging: boolean = false;

   public editable: boolean = false;
   public detail: any = '';

   @Prop()
   public data: any;

   public model: PreSaleModels.IListRow = {
      identifier: 'N/A',
      pictureOne: 'https://picsum.photos/300/150/?image=41',
      pictureTwo: 'https://picsum.photos/300/150/?image=40',
      title: '',
      fullAddress: '',
      price: -1,
      bedrooms: -1,
      bedroomsPlus: -1,
      washrooms: -1,
      garages: -1,
      parkingSpaces: -1,
      location: {
         streetNumber: '',
         streetName: '',
         postalCode: '',
         country: '',
         province: '',
         region: '',
         city: '',
      },
      remarks: '',
   };

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.model = val;
         if (this.$store.state.auth.userInfo.id.toString() === this.model.agentId) {
            this.editable = true;
         }
      }
      this.detail = this.model.remarks.client;
   }

   public async handleOffStage() {
      const _commonConfig = new CommonConfig();
      this.isOffStaging = true;
      const apiHost = _commonConfig.apiHost;
      const requestParams: any = {
         active: false,
         ltype: 1,
         rifoPropertyType: 'development-second'
      };
      requestParams.identifier = this.model.identifier;
      const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/rifoListings/add`, requestParams);
      this.isOffStaging = false;
      const noticeConfig: NoticeConfig = {
         title: 'Succeed',
         desc: 'Off Stage Succeed.'
      };
      this.$Notice.success(noticeConfig);
      this.$store.commit('presaleListReload');
   }
}
